import { useLayoutEffect, useRef, useState } from 'react'

export function useNearestShadowContainer(selector = '#mycontroller-main') {
  const anchorRef = useRef<HTMLSpanElement | null>(null)
  const [container, setContainer] = useState<HTMLElement | null>(null)

  useLayoutEffect(() => {
    let anchor = anchorRef.current
    if (!anchor) {
      const anchorElement = document.createElement('span')
      const main = document.querySelector(selector)
      main?.appendChild(anchorElement)
      anchor = anchorElement
    }

    const rootNode = anchor?.getRootNode?.()
    const root = rootNode instanceof ShadowRoot ? rootNode : document
    const el = (root as Document | ShadowRoot).querySelector(selector) as HTMLElement | null
    setContainer(el ?? null)
  }, [selector])

  return { anchorRef, container }
}
